module.exports = __webpack_public_path__ + "assets/img/96eb-tg.svg";